import { useContext, useState } from 'react';
import { APIContext } from '../../Contexts/APIContext';
import { SessionContext } from '../../Contexts/SessionContext';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid2';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import TextField from '@mui/material/TextField';

interface IDialogProps {
    open: boolean;
    onClose: () => void;
}

//validate inputs agains regex and table, add or remove if found else throw error message to user
export default function SitePickerDialog({ open, onClose }: IDialogProps) {
    const { get, showMessage } = useContext(APIContext);
    const { sessionState, setSessionField } = useContext(SessionContext);

    const [searchValue, setSearchValue] = useState<string>("");
    const regexp = new RegExp('^([A-Z]{2}-\\d{2}-[A-Z]-\\d{2})$');

    //#region methods
    const handleSearch = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setSearchValue(event.target.value.toUpperCase());
    };

    const clearSearch = () => {
        setSearchValue("");
    };

    //add new value to list
    const addFindValue = () => {
        if (regexp.test(searchValue)) {
            let sites = sessionState.landusePage.sites;
            if (!sites.includes(searchValue)) //new value
                //check db
                get('Site', `CheckSiteExists?reference=${searchValue}`, (data) => {
                    if (data) //ref value exists update the list
                    {
                        sites.push(searchValue);
                        setSessionField('landusePage.sites', sites);
                        showMessage("success", "Added " + searchValue);
                    }
                    else
                        showMessage("error", "Searched value does not exist")
                });
            else //duplicate value
                showMessage("error", "Value is already in the selected list");
        }
        else {
            showMessage("error", "Searched value is not in the correct format")
        }
    }

    //remove existing values from list
    const removeFindValue = () => {
        if (regexp.test(searchValue)) {
            let sites = sessionState.landusePage.sites;
            let pos: number = sites.indexOf(searchValue);
            if (pos !== -1) //value exists
            {
                sites.splice(pos, 1);
                setSessionField('landusePage.sites', sites);
                showMessage("success", "Removed " + searchValue);
            }
            else //if the value is not in the list
                showMessage("error", "You can not remove a value not in the selected list");
        }
        else {
            showMessage("error", "Searched value is not in the correct format")
        }
    }
    //#endregion

    return (
        <Dialog onClose={onClose} open={open} maxWidth="sm" fullWidth>
            <Grid container spacing={1}>
                <Grid size={8}>
                    <TextField
                        size="small"
                        onChange={handleSearch}
                        value={searchValue}
                        placeholder="Search..."
                        fullWidth
                        InputProps={{
                            endAdornment: searchValue && (
                                <IconButton
                                    size="small"
                                    aria-label="clear search"
                                    onClick={clearSearch}
                                >
                                    <CancelIcon fontSize="small" />
                                </IconButton>
                            )
                        }}
                    />
                </Grid>
                <Grid size={2}><Button onClick={() => addFindValue()}>Add</Button></Grid>
                <Grid size={2}><Button onClick={() => removeFindValue()}>Remove</Button></Grid>
            </Grid>
        </Dialog >);
}
